import { ReactComponent as Panel } from '../../../assets/images/menu_icons/panel.svg';
import { ReactComponent as Games } from '../../../assets/images/menu_icons/games.svg';
import { ReactComponent as Achievements } from '../../../assets/images/menu_icons/achievements.svg';
import { ReactComponent as Little_shop } from '../../../assets/images/menu_icons/little_shop.svg';
import { ReactComponent as Progress } from '../../../assets/images/menu_icons/progress.svg';
import { ReactComponent as Buy } from '../../../assets/images/menu_icons/buy.svg';
import { ReactComponent as Help_would } from '../../../assets/images/menu_icons/help_would.svg';
import { ReactComponent as Ranking } from '../../../assets/images/menu_icons/ranking.svg';

import logoAfinando from '../../../assets/images/logo/LogoDesktop.svg';
import logoCoelhoAfinandinho from '../../../assets/images/logo_pascoa2026.svg';
import logoCoelhoAfinandinhoMobile from '../../../assets/images/logo_pascoa.svg';
import logoJuninofinandinho from '../../../assets/images/logo_junino.png';
import logoNatalDesktop from '../../../assets/images/logo/LogoDesktopNatal.svg';
import logoNatalMobile from '../../../assets/images/logo/LogoMobileNatal.svg';
import LogoDesktopCopa from '../../../assets/images/logo/LogoDesktopCopa.svg';
import LogoMobileCopa from '../../../assets/images/logo/LogoMobileCopa.svg';

import {
  ALT_LOGO_AFINANDO,
  ALT_LOGO_AFINANDO_PASCOA,
  ALT_LOGO_AFINANDO_JUNINO,
} from '../../../constants/global';

import * as routes from '../../../constants/routes';

/**
 * Configuração de temas sazonais
 */
export const SEASONAL_THEMES = [
  {
    name: 'pascoa',
    start: new Date("2026-03-05T00:00:00"),
    end: new Date("2026-04-15T23:59:59"),
    logo: logoCoelhoAfinandinho,
    logoMobile: logoCoelhoAfinandinhoMobile,
    alt: ALT_LOGO_AFINANDO_PASCOA,
  },
  {
    name: 'junina',
    start: new Date('2025-06-01T00:00:00'),
    end: new Date('2025-07-29T23:59:59'),
    logo: logoJuninofinandinho,
    logoMobile: logoJuninofinandinho,
    alt: ALT_LOGO_AFINANDO_JUNINO,
  },
  {
    name: 'natal',
    start: new Date('2025-11-30T00:00:00'),
    end: new Date('2026-01-15T23:59:59'),
    logo: logoNatalDesktop,
    logoMobile: logoNatalMobile,
    alt: ALT_LOGO_AFINANDO,
  },
  {
    name: "copa",
    start: new Date("2026-05-20T00:00:00"),
    end: new Date("2026-07-20T23:59:59"),
    logo: LogoDesktopCopa,
    logoMobile: LogoMobileCopa,
    alt: ALT_LOGO_AFINANDO,
  }
];

/**
 * Configuração padrão do logo
 */
export const DEFAULT_LOGO = {
  logo: logoAfinando,
  alt: ALT_LOGO_AFINANDO,
};

/**
 * IDs únicos dos itens de navegação
 */
export const NAVIGATION_ITEM_IDS = {
  PANEL: 'panel',
  ACTIVITIES: 'activities',
  ACHIEVEMENTS: 'achievements',
  STORE: 'store',
  PROGRESS: 'progress',
  BUY: 'buy',
  HELP: 'help',
  RANKING: 'ranking',
  MORE: 'more',
};

/**
 * Configuração dos itens de navegação
 * @param {boolean} isUserAuthenticated - Se o usuário está autenticado
 * @param {boolean} hasNewReward - Se há nova recompensa disponível
 * @returns {Array} Array de itens de navegação
 */
export const getNavigationItems = (isUserAuthenticated, hasNewReward = false) => [
  {
    id: NAVIGATION_ITEM_IDS.PANEL,
    label: 'Painel',
    icon: Panel,
    route: isUserAuthenticated ? routes.R_DASHBOARD : routes.R_LOGIN,
    className: 'panel',
    showBadge: false,
    requiresAuth: false,
  },
  {
    id: NAVIGATION_ITEM_IDS.ACTIVITIES,
    label: 'Jogos',
    icon: Games,
    route: routes.R_ACTIVTS,
    className: 'activities',
    showBadge: false,
    requiresAuth: false,
  },
  {
    id: NAVIGATION_ITEM_IDS.ACHIEVEMENTS,
    label: 'Conquistas',
    icon: Achievements,
    route: isUserAuthenticated ? routes.R_ACHIEVEMENTS : routes.R_LOGIN,
    className: 'conquest',
    showBadge: false,
    requiresAuth: true,
  },
  {
    id: NAVIGATION_ITEM_IDS.STORE,
    label: 'Itens',
    icon: Little_shop,
    route: routes.R_COINSTORE,
    className: 'store',
    showBadge: hasNewReward,
    analytics: 'Menu Lateral - Itens',
    requiresAuth: false,
  },
  {
    id: NAVIGATION_ITEM_IDS.PROGRESS,
    label: 'Progresso',
    icon: Progress,
    route: isUserAuthenticated ? routes.R_PROGRESS : routes.R_LOGIN,
    className: 'progress',
    showBadge: false,
    requiresAuth: true,
  },
  {
    id: NAVIGATION_ITEM_IDS.RANKING,
    label: 'Ranking',
    icon: Ranking,
    route: routes.R_GAME_RANKING,
    className: 'ranking',
    showBadge: false,
    requiresAuth: true,
  },
  {
    id: NAVIGATION_ITEM_IDS.BUY,
    label: 'Comprar',
    icon: Buy,
    route: routes.R_BUY,
    className: 'buy',
    showBadge: false,
    requiresAuth: false,
  },
  {
    id: NAVIGATION_ITEM_IDS.HELP,
    label: 'Ajuda IA',
    icon: Help_would,
    route: routes.R_BOT_AFINANDO,
    className: 'help',
    showBadge: false,
    requiresAuth: false,
  },
];

/**
 * Labels de acessibilidade
 */
export const ARIA_LABELS = {
  MAIN_NAVIGATION: 'Navegação principal',
  CLOSE_MORE_MENU: 'Fechar menu mais opções',
  OPEN_MORE_MENU: 'Abrir mais opções',
  MORE_OPTIONS: 'Mais opções',
  LOGO_LINK: 'Ir para página inicial',
};